import CopyButton from './CopyButton';
export { CopyButton };
export default CopyButton;
